import { RiProfileFill, RiVipCrownFill } from "react-icons/ri";
import {
  AiTwotoneSound,
  AiFillDollarCircle,
  AiOutlineClear,
} from "react-icons/ai";
import { HiOutlineClipboardList } from "react-icons/hi";
import { TbPokerChip, TbMessage, TbMoneybag } from "react-icons/tb";
import { IoGift, IoSettings, IoWallet } from "react-icons/io5";
import { FaAddressCard, FaCalendarAlt, FaHeadphonesAlt } from "react-icons/fa";
import { HiShare } from "react-icons/hi";
import {
  closeColorMode,
  openCache,
  openChat,
  openColorMode,
  openLanguagePop,
} from "../../redux/action/member/memberAction";
import { MdOutlineLanguage } from "react-icons/md";
import { IoIosMoon, IoIosSend } from "react-icons/io";
import ThemeTab from "../../pages/Settings/components/themeTab";
import { useSelector } from "react-redux";
import {
  PiChartLineUpBold,
  PiSpeakerSimpleHighFill,
  PiSpeakerSimpleNoneFill,
  PiSpeakerSimpleXFill,
} from "react-icons/pi";
import { useMemo } from "react";
import { BiSolidLockAlt, BiSolidUserCircle } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { COMMON_WEB_PATH, WEB_LAYOUT } from "../../constant";
import { BsShieldFillCheck } from "react-icons/bs";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toggleBGM } from "../../redux/action/action";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import memberSpeaker from './images/member_speaker.png'

const iconStyle = "text-2xl mr-[10px]";

const isCredit = process.env.REACT_APP_CREDIT == "1";

export const MENU_LIST = ({ className, dispatch }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const i18n_setting = (key) => t(`settings.${key}`);

  const [_searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { is911vipCC } = useWebsiteInfo();

  const isMemberInfo = useSelector((state) => state.isMemberInfo);
  const isBGMEnabled = useSelector((state) => state.isBGMEnabled);
  const { song, enabled } = isBGMEnabled || {};

  const withdraw_password_set = useMemo(() => {
    return isMemberInfo?.withdraw_password_set == 1;
  }, [isMemberInfo]);

  const menu = {
    more: [
      // {
      //   icon: IoGift,
      //   text: i18n("rewards"),
      //   link: "rewards",
      //   iconColor: "#6448FF",
      //   auth: true,
      //   // hidden: isCredit,
      // },
      {
        icon: PiChartLineUpBold,
        text: i18n("rebate"),
        link: "my-rebate",
        iconColor: "#963EFF",
        auth: true,
        hidden: isCredit,
        image: `${COMMON_WEB_PATH}/911TW/rebateICON.webp`,
      },
      {
        icon: TbMessage,
        text: i18n("inbox"),
        link: "inbox",
        iconColor: "#D6DDFF",
        iconTextColor: "#537CFF",
        auth: true,
        image: `${COMMON_WEB_PATH}/911TW/inboxICON.webp`,
      },
      // {
      //   icon: FaHeadphonesAlt,
      //   text: i18n("serviceInformation"),
      //   link: "service-group",
      //   func: () => {
      //     dispatch(openChat());
      //     navigate("/service-group"); // 直接在 func 中處理導航
      //   },
      //   // func: () => {
      //   //   dispatch(openChat());
      //   // },
      //   iconColor: "#88919A",
      //   hidden: isCredit || is911vipCC,
      //   image: `${COMMON_WEB_PATH}/911TW/serviceInformationICON.webp`,
      // },
    ],
    basic: [
      {
        icon: IoSettings,
        text: i18n("settings"),
        link: "settings",
        iconColor: "#88919A",
        auth: true,
        image: `${COMMON_WEB_PATH}/911TW/settingsICON.webp`,
      },

      {
        icon: MdOutlineLanguage,
        text: i18n("language"),
        link: "language",
        func: () => {
          dispatch(openLanguagePop());
        },
        border: true,
        iconColor: "#88919A",
        image: `${COMMON_WEB_PATH}/911TW/languageICON.webp`,
      },
      // {
      //   icon: IoIosMoon,
      //   text: i18n("color-mode"),
      //   link: "color-mode",
      //   func: () => {
      //     dispatch(openColorMode());
      //   },
      //   border: true,
      //   iconColor: "#88919A",
      //   hidden: WEB_LAYOUT == "v2",
      // },
      {
        icon: AiOutlineClear,
        text: i18n("clearcache"),
        link: "clear-cache",
        func: () => {
          dispatch(openCache());
        },
        iconColor: "#88919A",
        image: `${COMMON_WEB_PATH}/911TW/clearcacheICON.webp`,
      },
      {
        icon: enabled ? PiSpeakerSimpleXFill : PiSpeakerSimpleHighFill,
        text: i18n("sound"),
        // link: "color-mode",
        func: () => {
          dispatch(
            toggleBGM({
              ...isBGMEnabled,
              enabled: !enabled,
            }),
          );
        },
        border: true,
        iconColor: "#88919A",
        hidden: WEB_LAYOUT == "v2",
        image: `${COMMON_WEB_PATH}/911TW/soundICON.webp`,
      },
      {
        text: i18n("announcement"),
        link: "announcement",
        func: () => {
          setSearchParams({ announcement_open: "true" });
        },
        iconColor: "#88919A",
        image: memberSpeaker
      },
    ],
  };

  return menu;
};
